var htmlElement = document.querySelector('html');
var visualElement = document.querySelector('.js-header-visual');
var visualGradient = document.querySelector(".c-header-visual__gradient")
var headerElement = document.querySelector('.js--header');
var mainContentElement = document.querySelector('.js-main-content');

/*
 * Adds a class to the header elememt when the visual element doesn't have a gradient
 */
function handleNoGradient() {
    if (headerElement !== null) {
      //console.log(visualElement,visualGradient)
        if (visualElement && visualGradient) {
					headerElement.classList.add("c-header--no-gradient")
				}
    }
}

/*
 * Measures the height of the absolute positioned header element and
 * adds that as a margin top the main content
 */
function positionMainContent() {
    if (!htmlElement.classList.contains('p-homepage')) {
        if (headerElement && mainContentElement) {
            var headerHeight = headerElement.offsetHeight;
            mainContentElement.style.marginTop = headerHeight + 'px';
        }
        if (visualElement) {
            visualElement.style.marginTop = '-' + headerHeight + 'px';
        }

    }
    if (htmlElement.classList.contains('p-homepage') && visualElement == null) {
        if (headerElement && mainContentElement) {
            var headerHeight = headerElement.offsetHeight;
            mainContentElement.style.marginTop = headerHeight + 'px';
        }
    }
}

function init() {
    handleNoGradient();
    positionMainContent();
}

_.defer(init);
